/**
 * JavaScript Utility - array/pluck
 * @author 서명환 <mhseo@ulalalab.com>
 */
function pluck(array = [], propertyName) {
  return array.map((item = {}) => item[propertyName]);
}

export default pluck;
